import { motion } from 'framer-motion'

interface CTASectionProps {
  title: string
  description: string
  primaryButtonText: string
  secondaryButtonText?: string
  onPrimaryClick?: () => void
  onSecondaryClick?: () => void
  className?: string
}

const CTASection = ({ 
  title, 
  description, 
  primaryButtonText, 
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  className = ''
}: CTASectionProps) => {
  return (
    <section className={`py-16 gradient-bg ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {title}
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            {description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onPrimaryClick}
              className="bg-white text-primary-600 hover:bg-gray-100 font-medium py-3 px-8 rounded-lg transition-colors duration-200"
            >
              {primaryButtonText}
            </button>
            {secondaryButtonText && (
              <button 
                onClick={onSecondaryClick}
                className="border-2 border-white text-white hover:bg-white hover:text-primary-600 font-medium py-3 px-8 rounded-lg transition-colors duration-200"
              >
                {secondaryButtonText}
              </button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default CTASection
